<template>
  <div class="top-0 right-0 rounded-full" :class="indicatorClass"></div>
</template>

<script>
export default {
  props: { indicatorClass: { type: String, default: '' } }
}
</script>
